export const EventUtils = {
  checkOfflineFormat(formats: string[], isOfflineRegClosed?: boolean) {
    if (!isOfflineRegClosed) {
      return formats;
    }

    return formats.filter((format: string) => format !== eventFormat.OFFLINE);
  },
};

export enum eventFormat {
  OFFLINE = 'offline',
  ONLINE = 'online',
}
